/**
 * What the login page says when the MyStateMLS "Create my website" button could not sign a member
 * in (gateway routes/partner-launch.ts sends them here with ?launch_error=<reason>).
 */
const MESSAGES: Record<string, string> = {
  email_in_use:
    'Your MyStateMLS email already has a Bread List account. Sign in below with your password, or use “Forgot password?” to set one.',
  two_factor: 'Your account uses two-step sign-in, so sign in below with your password and code.',
  expired: 'That link from MyStateMLS has expired. Go back to MyStateMLS and click the button again.',
  used: 'That link from MyStateMLS can’t be used again. Go back to MyStateMLS and click the button again.',
  invalid: 'That link from MyStateMLS could not be checked. Go back to MyStateMLS and click the button again.',
  unknown_member: 'We could not find your membership in the MyStateMLS roster yet. Please contact MyStateMLS support.',
  inactive_member: 'Your MyStateMLS membership shows as inactive, so we could not create your site. Please contact MyStateMLS support.',
  no_email: 'MyStateMLS has no email address for you, which your website account needs. Add one in MyStateMLS, then try again.',
  in_progress: 'Your website account is being set up. Wait a moment, then click the button in MyStateMLS again.',
  account_inactive: 'Your Bread List account is not active. Please contact support.',
  roster_unavailable: 'We could not reach the MyStateMLS roster just now. Please try again in a few minutes.',
  unavailable: 'Signing in from MyStateMLS is not available right now. Please try again in a few minutes.',
};

export function launchErrorMessage(reason: string | null): string | null {
  if (!reason) return null;
  return MESSAGES[reason] ?? MESSAGES.unavailable!;
}

/** What the login page says when Sign in with Google could not sign someone in (gateway routes/google-auth.ts, ?google_error=). */
const GOOGLE_MESSAGES: Record<string, string> = {
  no_account:
    'No Bread List account uses that Google email. Sign in below with your password, or create an account first.',
  other_google: 'This Bread List account is linked to a different Google account. Sign in with that one, or with your password below.',
  unverified_email: 'Google has not verified the email on that Google account, so we can’t use it to sign you in.',
  blocked: "This account can't sign in. Please contact support.",
  cancelled: 'Google sign-in was canceled.',
  expired: 'That Google sign-in expired. Please try again.',
  bad_token: 'Google sign-in could not be checked. Please try again.',
  unavailable: 'Signing in with Google is not available right now. Sign in with your password below.',
};

export function googleErrorMessage(reason: string | null): string | null {
  if (!reason) return null;
  return GOOGLE_MESSAGES[reason] ?? GOOGLE_MESSAGES.unavailable!;
}
